/**
 * Darstellung (Hell/Dunkel/System) je Benutzer — im Browser gespeichert.
 *
 * Familienbaustein: liegt als Kopie auch in Wissensdatenbank und
 * Außendienst-Portal. Quelle ist Canalis; Aenderungen zuerst hier.
 * Das fruehe Setzen vor dem ersten Anstrich uebernimmt ein kleines
 * Skript in index.html — dieselbe Speicherstelle, derselbe Schluessel.
 */

import { useState } from 'react';

export type ThemePreference = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'themePreference';

export function readThemePreference(): ThemePreference {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'light' || value === 'dark' ? value : 'system';
  } catch {
    return 'system';
  }
}

export function applyThemePreference(preference: ThemePreference): void {
  if (preference === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = preference;
  try {
    if (preference === 'system') localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, preference);
  } catch {
    // Speicher gesperrt (z. B. privates Fenster) — die Wahl gilt dann
    // nur fuer die laufende Sitzung.
  }
}

const LABELS: Record<ThemePreference, string> = {
  system: 'System',
  light: 'Hell',
  dark: 'Dunkel',
};

const NEXT: Record<ThemePreference, ThemePreference> = {
  system: 'dark',
  dark: 'light',
  light: 'system',
};

/** Schaltet beim Klick weiter: System → Dunkel → Hell → System. */
export function ThemeButton({ className }: { className?: string }) {
  const [preference, setPreference] = useState<ThemePreference>(readThemePreference);

  const cycle = () => {
    const next = NEXT[preference];
    applyThemePreference(next);
    setPreference(next);
  };

  return (
    <button
      type="button"
      className={className}
      onClick={cycle}
      title="Darstellung wechseln: Hell, Dunkel oder Systemeinstellung"
    >
      Darstellung: {LABELS[preference]}
    </button>
  );
}
